import ReactQuill, { Quill } from 'react-quill-new'

const Inline = Quill.import('blots/inline')

class SpoilerBlot extends Inline {
    static create() {
        const node = super.create()
        node.classList.add('tg-spoiler')
        return node
    }

    static formats(node) {
        return node.classList.contains('tg-spoiler')
    }
}

// Регистрация Blot
SpoilerBlot.blotName = 'spoiler'
SpoilerBlot.tagName = 'span'
Quill.register(SpoilerBlot)

const CustomIcons = Quill.import('ui/icons')

CustomIcons['spoiler'] = `<svg
    title="Скрытый"
    viewBox="0 0 1024 1024"
    focusable="false"
    data-icon="eye-invisible"
    width="18"
    height="18"
    fill="currentColor"
    aria-hidden="true"
>
    <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"></path>
    <path d="M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"></path>
</svg>`

CustomIcons['code-block'] =
    `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 860 860" width="18" fill="currentColor"><path d="m384-360 51-51-69-69 69-69-51-51-120 120 120 120Zm192 0 120-120-120-120-51 51 69 69-69 69 51 51ZM216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-528H216v528Zm0-528v528-528Z"/></svg>`

export { ReactQuill }
